import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CheckoutFormTransfiyaComponent } from './components/checkout-form-transfiya.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'angular-monorepo-checkout-transfiya',
  standalone: true,
  imports: [CommonModule, CheckoutFormTransfiyaComponent],
  templateUrl: './checkout-transfiya.component.html',
  styleUrl: './checkout-transfiya.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckoutTransfiyaComponent {
}
